import React, { useEffect, useMemo, useState } from 'react';
import ViewQuestion from "./ViewQuestion";
import MultiChoicesAnswerAnalysis from './MultiChoicesAnswerAnalysis';
import OpenEndedAnswerAnalysis from './OpenEndedAnswerAnalysis';
import { BASE_URL, QuestionTypes } from '../constants';
import { FaPlay } from "react-icons/fa";
import ReactPlayer from 'react-player/lazy'
import IsLoading from './IsLoading';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import axios from 'axios';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';

export const handleInisStudentSelfLearningMode = (response_data_data,questionStylesInisStudentSelfLearningMode) => {
  const tmp = { ...questionStylesInisStudentSelfLearningMode };
  response_data_data.forEach(element => {
    
    const question_id = element?.question_id;
    if (tmp.hasOwnProperty(question_id)) {
      delete tmp[question_id]; 
    }
    tmp[question_id] = {};
    const is_student_answer_correct = !!((element?.is_student_answer_correct ?? 0) - 0);
    const remaining_num_of_tries = (element?.remaining_num_of_tries ?? 0) - 0;
    tmp[question_id].is_student_answer_correct = is_student_answer_correct;
    tmp[question_id].remaining_num_of_tries = remaining_num_of_tries;
    const flagRethink = remaining_num_of_tries && (!is_student_answer_correct);
    tmp[question_id].flagRethink = flagRethink;
    if (!flagRethink) {
      const explanation = element?.explanation
      tmp[question_id].explanation = explanation;
      const the_correct_answer = element?.the_correct_answer;
      tmp[question_id].the_correct_answer = the_correct_answer;
    }
    
  });
  return tmp;
}

const InteractiveVideo = ({
  videoRef,
  questions,
  setQuestions,
  videoUrl,
  isPlaying,
  setIsPlaying,
  isToggle,
  hitQuestion,
  setHitQuestion,
  question,
  setQuestion,
  setFullStyle,
  interactiveMode,
  analysisMode,
  currentQuestionTime,
  setCurrentQuestionTime,
  onProgressEvents,
  setOnProgressEvents,
  onReadyEvents,
  setOnReadyEvents,
  volume,
  setVolume,
  mediaLoaded,
  lastHitTime,
  setLastHitTime,
  isStudentSelfLearningMode,
  questionStylesInisStudentSelfLearningMode,
  setQuestionStylesInisStudentSelfLearningMode
}) => {
  const student_id = useSelector(state => state.user.details.userId);
  const handlePlayPause = () => {
    const video = videoRef.current;
    setIsPlaying(!isPlaying);

    if (hitQuestion) {
      video?.id == 'video' && video.pause();
      setIsPlaying(false);
    }
    else if (isPlaying) {
      video?.id == 'video' && video.pause();
    }
    else {
      video?.id == 'video' && video.play();
    }
  };

  // object with question times as questions keys
  const questionsTimeStamp = useMemo(() => {
    const timeStamp = {};

    questions.forEach(q => {
      timeStamp[q?.time] = q
    })

    return timeStamp;
  }, [questions]);



  const fetchDataInStudentSelfLearningMode = async () => {

    try {
      if (isStudentSelfLearningMode) {
        Swal.showLoading();
        const questionIds = questions.map(q => q?.id).join(",");
        axios.get(`${BASE_URL}/lesson/questionAnswerInStudentSelfLearningMode.php?questionIds=${questionIds}&student_id=${student_id}`).then((response) => {
          Swal.close()
          const response_data_data = response?.data?.data;
          if (response_data_data?.length) {
            const x = handleInisStudentSelfLearningMode(response_data_data ?? [],questionStylesInisStudentSelfLearningMode??{});
            setQuestionStylesInisStudentSelfLearningMode(x);
          }
        }).catch(e => {
        })
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    fetchDataInStudentSelfLearningMode();
  }, [])


  useEffect(() => {
    const video = videoRef.current;

    const handleTimeUpdate = () => {
     

      const curr = video?.id == 'video' ? video.currentTime : video.getCurrentTime();
      const popQuestion = questionsTimeStamp[Math.ceil(curr-1)]??questionsTimeStamp[Math.ceil(curr-2)];
     //console.log(questionsTimeStamp,popQuestion,curr);
      console.log(lastHitTime,curr,Math.abs(lastHitTime-curr  ))
      if (
        popQuestion
        && Math.abs(lastHitTime-curr  ) > 2
        && !hitQuestion
        && currentQuestionTime != popQuestion?.time
        && isToggle
      ) {
        console.log("ff")
        setQuestion(popQuestion);
        setIsPlaying(false)
        setHitQuestion(true);
        setLastHitTime(curr);
        setCurrentQuestionTime(popQuestion?.time);
        video?.id == 'video' && video.pause();
      }
    };

    if (video?.id == 'video') {
      video.addEventListener('timeupdate', handleTimeUpdate);

      return () => {
        video.removeEventListener('timeupdate', handleTimeUpdate);
      };
    } else {
      !onProgressEvents.some(func => func.toString() == handleTimeUpdate.toString()) &&
        setOnProgressEvents([...onProgressEvents, handleTimeUpdate])
    }

  }, [Object.keys(questionsTimeStamp).length, mediaLoaded, hitQuestion, currentQuestionTime,lastHitTime])

  console.log(videoUrl)
   if(videoUrl?.includes("youtube") ) {
      console.log(videoRef);
     if (!videoRef ) return <IsLoading />
   }else {

     if (!videoRef  ) return <IsLoading />
   }
  return (
    <div onClick={handlePlayPause} className='relative h-full mx-auto w-100'
      style={{
        aspectRatio: "16 / 9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {
        videoUrl?.includes("youtube") ?
          <ReactPlayer
            progressInterval={1250}
            volume={volume}
            onProgress={() => onProgressEvents?.forEach(action => action())}
            onReady={() => onReadyEvents?.forEach(action => action())}
            config={{
              youtube: {
                playerVars: {
                  showinfo: 0 // Hides the video title
                }
              }
            }}
            playing={isPlaying}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            ref={videoRef} id="youtube_video"
            style={{ minWidth: "100%", minHeight: "100%" }}
            controls={false}
            url={`https://www.youtube.com/embed/${videoUrl.split("watch?v=")[1]}`} />
          : <video
            ref={videoRef} id="video"
            className='cursor-pointer h-full'
            src={videoUrl} />
      }

      {
        !isPlaying &&
        <div className='absolute inset-0 flex items-center justify-center cursor-pointer'>
          <div className='opacity-70 text-gray-50 bg-black rounded-full w-1/5 p-[4%]'>
            {mediaLoaded ? <FaPlay className='w-full h-fit' /> : <AiOutlineLoading3Quarters className='animate-spin w-full h-fit' />}
          </div>
        </div>
      }

      {hitQuestion && !analysisMode &&
        <ViewQuestion
          videoRef={videoRef}
          questions={questions} setQuestions={setQuestions}
          hitQuestion={hitQuestion} setHitQuestion={setHitQuestion}
          question={question}
          isPlaying={isPlaying} setIsPlaying={setIsPlaying}
          setFullStyle={setFullStyle}
          interactiveMode={interactiveMode}
          isStudentSelfLearningMode={isStudentSelfLearningMode}
          questionStylesInisStudentSelfLearningMode={questionStylesInisStudentSelfLearningMode}
          setQuestionStylesInisStudentSelfLearningMode={setQuestionStylesInisStudentSelfLearningMode}
        />}

      {hitQuestion && analysisMode && question.type == QuestionTypes.multiChoices &&
        <MultiChoicesAnswerAnalysis question={question} />}

      {hitQuestion && analysisMode && question.type == QuestionTypes.essay &&
        <OpenEndedAnswerAnalysis question={question} />}
    </div>
  );
};

export default InteractiveVideo;